import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
// import styles from '../FeatureDetail.module.scss';
import {
  getNotes,
  saveNewNote,
  deleteNoteById,
  editNoteById,
} from '../../../../services/udapi/notes';
import { NOTEABLE_TYPES } from '../../../../lib/constants';
import styles from './Notes.module.scss';
import Panel from '../../Panel';
import Note from './Note';
import Button from '../../../Button';
import Loader from '../../../Loader';

function Notes(props) {
  const { noteableId, noteableType, isOwner } = props;

  const [notes, setNotes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [featuresSaving, setFeaturesSaving] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const [newNote, setNewNote] = useState({ title: '', contents: '' });
  const [isNoteSaveable, setIsNoteSaveable] = useState(false);
  const [isSavingNew, setIsSavingNew] = useState(false);
  const [error, setError] = useState(null);

  const saveNote = () => {
    setIsSavingNew(true);
    saveNewNote(noteableType, noteableId, newNote)
      .then((res) => {
        if (res.success) {
          setNotes([{ ...newNote, ...res.data }, ...notes]);
          setNewNote({ title: '', contents: '' });
          setIsAdding(false);
        }
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setIsSavingNew(false);
      });
  };

  const updateNote = (id, title, contents, updated) => {
    const newNotesList = notes.map((note) => {
      if (note.uuid == id) {
        return {
          ...note,
          title,
          contents,
          updatedAt: updated,
        };
      } else {
        return note;
      }
    });

    setNotes(newNotesList);
  };

  const editNote = (noteId, title, contents) => {
    setFeaturesSaving([...featuresSaving, noteId]);
    editNoteById(noteId, title, contents)
      .then((res) => {
        if (res.success) {
          updateNote(noteId, title, contents, res.data.updatedAt);
        }
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setFeaturesSaving(featuresSaving.filter((id) => id !== noteId));
      });
  };

  const deleteNote = (noteId) => {
    deleteNoteById(noteId)
      .then((res) => {
        if (res.success) {
          setNotes(notes.filter((note) => note.uuid != noteId));
        }
      })
      .catch((err) => {
        setError(err);
      });
  };

  useEffect(() => {
    getNotes(noteableType, noteableId)
      .then((res) => {
        if (res.success) {
          setNotes(res.data);
        }
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [noteableId, noteableType]);

  const cancelAdding = () => {
    setIsAdding(false);
  };

  return (
    <Panel
      title="Notes"
      count={notes.length}
      collapsible={true}
      actions={isOwner ? [
        {
          name: '+Add',
          disabled: isAdding,
          onClick: () => {
            setIsAdding(true);
          },
        },
      ] : []
      }
    >
      {isLoading ? (
				<div className={styles.loaderContainer}>
					<Loader active={isLoading} />
				</div>
			) : null}
      <div className={styles.notesList}>
        {isAdding ? (
          <div className={styles.newNoteForm}>
            <div className={styles.newNoteInputs}>
              <input
                type="text"
                placeholder="Title"
                value={newNote.title}
                maxLength={255}
                onChange={(e) => {
                  setNewNote({ ...newNote, title: e.target.value });
                }}
              />
              <textarea
                placeholder="Add note..."
                value={newNote.contents}
                onChange={(e) => {
                  const contents = e.target.value
                  setIsNoteSaveable(contents.trim())
                  setNewNote({ ...newNote, contents });
                }}
              />
            </div>
            <div className={styles.buttonsContainer}>
              <Button
                size={Button.SIZE.small}
                theme={Button.THEME.outlinePrimary}
                onClick={cancelAdding}
              >
                Cancel
              </Button>
              <Button
                disabled={!isNoteSaveable}
                onClick={saveNote}
                size={Button.SIZE.small}
                theme={Button.THEME.solidPrimary}
              >
                Save Note
              </Button>
            </div>
          </div>
        ) : null}
        {notes.length == 0 && !isLoading ? (
          <div className={styles.noNotes}>No notes...yet.</div>
        ) : (
          notes.map((note) => {
            return (
              <Note
                noteId={note.uuid}
                title={note.title}
                contents={note.contents}
                createdAt={note.createdAt}
                updatedAt={note.updatedAt}
                onDelete={deleteNote}
                onSaveEdit={editNote}
                isLoading={featuresSaving.includes(note.uuid)}
                key={note.uuid}
                isOwner={isOwner}
              />
            );
          })
        )}
      </div>
    </Panel>
  );
}

Notes.propTypes = {
  isOwner: PropTypes.bool,
  noteableId: PropTypes.string,
  noteableType: PropTypes.oneOf(Object.values(NOTEABLE_TYPES)),
};

export default connect((model) => ({}))(Notes);
